import { Component } from '@angular/core';

@Component({
  selector: 'app-submission',
  imports: [],
  templateUrl: './submission.component.html',
  styleUrl: './submission.component.scss'
})
export class SubmissionComponent {

}
